import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-no-permissions',
  templateUrl: './no-permissions.component.html',
  styleUrls: ['./no-permissions.component.scss']
})
export class NoPermissionsComponent implements OnInit {

  constructor() { }

  ngOnInit(): void { }

}
